import { NgModule } from '@angular/core';

import { TooltipDirective } from './tooltip.directive';
import { ColorMealTypeDirective } from './color-meal-type.directive';

export const directives = [
  TooltipDirective,
  ColorMealTypeDirective
];

@NgModule({
  declarations: [
    ...directives
  ],
  exports: [
    ...directives
  ]
})
export class DirectivesModule { }
